<template>
    <div class="card shadow-sm mb-4">
        <div class="card-header border-bottom-0 bg-white">
            <div class="d-flex align-items-center justify-content-start">
                <div class="avatar border rounded text-center p-1">
                    <img src="../../assets/logo_icon.svg" class="h-100 w-100 mx-auto" alt="MySwitchPro">
                </div>
                <div class="d-flex flex-column justify-content-around ml-3">
                    <div class="text-info font-weight-bold">MySwitchPro</div>
                    <small class="text-muted"> {{ notification.created_at | dateFormat }}</small>
                </div>
            </div>
        </div>
        <div class="card-body">
            <switch-in-progress v-if="types.switch_in_progress === notification.type" :notification="notification"/>
            <switch-completed v-if="types.switch_completed === notification.type" :notification="notification"/>
            <recommendation-received v-if="types.recommendation_received === notification.type"
                                     :notification="notification"/>
            <switch-objection v-if="types.switch_objection === notification.type" :notification="notification"/>
            <referee-registered v-if="types.referee_registered === notification.type" :notification="notification" />
            <reward-received v-if="types.reward_received === notification.type" :notification="notification"/>
            
            <no-better-deal v-if="types.recommendation_not_received === notification.type"/>
        </div>
    </div>
</template>

<script>
import SwitchCompleted from "@/components/notifications/SwitchCompleted";
import SwitchInProgress from "@/components/notifications/SwitchInProgress";
import RecommendationReceived from "@/components/notifications/RecommendationReceived";
import SwitchObjection from "@/components/notifications/SwitchObjection";
import NoBetterDeal from "@/components/notifications/NoBetterDeal";
import RewardReceived from "@/components/notifications/RewardReceived";
import RefereeRegistered from "@/components/notifications/RefereeRegistered";

const moment = require('moment')

const types = {
    referee_registered: 'referee_registered',
    reward_received: 'reward_received',
    switch_in_progress: 'switch_in_progress',
    recommendation_received: 'recommendation_received',
    switch_objection: 'switch_objection',
    switch_completed: 'switch_completed',
    recommendation_not_received: 'recommendation_not_received'
}

export default {
    name: "Notification",
    components: {
        RefereeRegistered,
        RewardReceived,
        NoBetterDeal,
        SwitchObjection,
        RecommendationReceived,
        SwitchInProgress,
        SwitchCompleted
    },
    props: {
        notification: Object
    },
    data() {
        return {
            types: types,
            switchObjectedTariff: null,
        }
    },
    filters: {
        dateFormat: function (date) {
            return moment(date * 1000).format('Do MMMM, YYYY')
        }
    },
}
</script>

<style scoped lang="scss">

@import "../../sass/base";

.avatar {
    width: 40px;
    height: 40px;
}

@include media-breakpoint-down(lg) {
    .border-right {
        border-right: none !important;
    }
}

@include media-breakpoint-up(lg) {
    .border-bottom {
        border-bottom: none !important;
    }
}
</style>
